import { render, staticRenderFns } from "./security.vue?vue&type=template&id=6a24e526&scoped=true&"
import script from "./security.vue?vue&type=script&lang=js&"
export * from "./security.vue?vue&type=script&lang=js&"
import style0 from "./security.vue?vue&type=style&index=0&id=6a24e526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24e526",
  null
  
)

export default component.exports